import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import "./Filter.css";
import { setSearchKey } from "../../../features/products/productSlice";
import { fetchCategories } from "../../../features/products/categoriesSlice";

/**
 * Component that displays the filter page
 *
 * @return {JSX.Element} Filter component JSX
 */
export default function Filter() {
  const dispatch = useDispatch();
  const { id: selectedCat } = useParams();
  const navigate = useNavigate();

  const {
    items: categories,
    loading,
    error
  } = useSelector((state) => state.categories);

  useEffect(() => {
    if (!categories.length) {
      dispatch(fetchCategories());
    }
  }, [dispatch, categories.length]);

  const handleFilterClick = (categoryId) => {
    dispatch(setSearchKey(""));
    navigate(`/products/${categoryId}`);
  };

  if (loading) return <div>Loading categories...</div>;
  if (error) return <div>Error loading categories</div>;

  // Don't render if there's only one category
  if (categories.length <= 1) return null;

  return (
    <>
      <div className="filter_title">Explore our categories</div>
      <div className="filter_image_container">
        {categories.map((cat) => (
          <div className="filter_item" key={cat.id}>
            <button
              key={cat.id}
              onClick={() => handleFilterClick(cat.id)}
              className={
                String(selectedCat) === String(cat.id)
                  ? "filter_btn_selected"
                  : "filter_btn"
              }
            >
              {cat.name}
            </button>
          </div>
        ))}
      </div>
    </>
  );
}
